import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { CommonDirectives } from '@app/shared/directives/common-directives';

@Component({
  selector: 'app-mat-stepper-navigation',
  imports: [MatButtonModule, CommonDirectives],
  templateUrl: './mat-stepper-navigation.component.html'
})
export class MatStepperNavigationComponent {
  @Input() buttonOneTitle!: string;
  @Input() buttonTwoTitle!: string;
  @Input() buttonThreeTitle!: string;
  @Input() buttonOneDisabled: boolean = false;
  @Input() buttonTwoDisabled: boolean = false;
  @Input() buttonThreeDisabled: boolean = false;
  @Output() onButtonOneClick = new EventEmitter();
  @Output() onButtonTwoClick = new EventEmitter();
  @Output() onButtonThreeClick = new EventEmitter();

  handleButtonOneClick() {
    this.onButtonOneClick.emit();
  }

  handleButtonTwoClick() {
    this.onButtonTwoClick.emit();
  }

  handleButtonThreeClick() {
    this.onButtonThreeClick.emit();
  }
}
